import { render, staticRenderFns } from "./LimsDrawer.vue?vue&type=template&id=42e609d8&scoped=true"
import script from "./LimsDrawer.vue?vue&type=script&lang=js"
export * from "./LimsDrawer.vue?vue&type=script&lang=js"
import style0 from "./LimsDrawer.vue?vue&type=style&index=0&id=42e609d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e609d8",
  null
  
)

export default component.exports